import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment/moment'
import { setIndividual } from '../../../../redux/actions/careReceipients'
import { setPrivateIndividual } from '../../../../redux/actions/quizQuestions'
import CalendarIcon from '../../../../icons/calendar.svg'
import Calendar from 'react-calendar'
import styles from '../../../Pages/Common/Footer/footer.module.scss'
import RightArrow from '../../../../icons/rightArrowIcon.svg'
import LeftArrow from '../../../../icons/leftArrowIcon.svg'
import ArrowBtn from '../../../../icons/arrowBtn.svg'
import Close from '../../../../icons/close.svg'
import cx from 'classnames'
import Logo from '../../../../icons/miniLogo.svg'
import Time from '../../../../icons/time.svg'
import Amount from '../../../../icons/amount.svg'
import { listEntryRepresentationByPrivateIndividual } from '../../../../constants/quizConstant'
import AttachFile from '../../../../icons/attach.svg'
import { deleteFile, uploadFile } from '../../../../api/formApi'
import { type } from '@testing-library/user-event/dist/type'
const QuizPrivateIndividual = ({
  parentState,
  setParentState,
  currentIndexIndividual,
}) => {
  const {
    privateIndividual: { quizPrivate, indexPrivate },
    availableDays,
  } = useSelector((state) => state.quizQuestions)
  const {
    representationByPrivateIndividual,
    authorizedPerson: { periodOfAbsenceFrom, periodOfAbsenceTo },
    representativePerson,
    payment: { reimbursementRef },
  } = useSelector((state) => state)
  const dispatch = useDispatch()
  const [question, setQuestion] = useState('')
  const [duration, setDuration] = useState('')
  const [amount, setAmount] = useState('')
  const [showCalendar, setShowCalendar] = useState(false)
  const wrapper = useRef(null)
  const inputRef = useRef(null)
  const [dates, setDates] = useState([])
  let notObjIndex = indexPrivate - availableDays
  let removedItem = indexPrivate - availableDays
  const [fileName, setFileName] = useState('')
  const currentDate = new Date()
  const [openFiles, setOpenFiles] = useState(false)
  const [fileArray, setFileArray] = useState([])
  const buttonGroupRefPrivate = useRef(null)

  const [windowWidth, setWindowWidth] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  })
  const handleResize = () => {
    setWindowWidth({
      width: window.innerWidth,
      height: window.innerHeight,
    })
  }
  useEffect(() => {
    window.addEventListener('resize', handleResize)

    // Remove event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])
  useEffect(() => {
    document.addEventListener('click', handleClickOut, false)
    return () => {
      document.removeEventListener('click', handleClickOut, false)
    }
  }, [])
  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    return `${day}.${month}.${year}`
  }

  // Function to generate the date range iteratively to avoid misordering
  const generateDateRange = (start, end) => {
    const startDate = new Date(start.split('.').reverse().join('-')) // Convert 'DD.MM.YYYY' to 'YYYY-MM-DD'
    const endDate = new Date(end.split('.').reverse().join('-'))
    const dateArray = []

    let currentDate = startDate
    while (currentDate <= endDate) {
      dateArray.push(formatDate(currentDate)) // Add formatted date
      currentDate.setDate(currentDate.getDate() + 1) // Move to the next day
    }

    return dateArray
  }

  // Generate the date interval when the component mounts
  useEffect(() => {
    const startDate = convertToDate(periodOfAbsenceFrom)
    const endDate = convertToDate(periodOfAbsenceTo)
    const generatedDates = generateDateRange(startDate, endDate)
    setDates(generatedDates) // Set the generated dates in state
  }, [periodOfAbsenceFrom, periodOfAbsenceTo])
  const invalidChars = ['e', 'E', '.', ',', '-', '+']
  const handleClickOut = (event) => {
    if (wrapper.current && !wrapper.current.contains(event.target)) {
      setShowCalendar(false)
    }
  }
  const handleClick = (e, itemQuestion) => {
    const buttons = buttonGroupRefPrivate.current?.querySelectorAll(
      'input[type="submit"]',
    )
    buttons?.forEach((btn) => btn.classList.remove(styles.active))
    e.target.classList.add(styles.active)
    handleChangeAnswer(e, itemQuestion) // Your original handler
  }
  const handleChangeAnswer = (e, itemQuestion) => {
    setParentState(e.currentTarget.value)
    setQuestion(itemQuestion)
  }
  const handleChangeDuration = (e) => {
    if (/^\d*\.?\d*$/.test(e.currentTarget.value)) {
      if (
        e.currentTarget.value === '' ||
        (!isNaN(e.currentTarget.value) &&
          Number(e.currentTarget.value) >= 0 &&
          Number(e.currentTarget.value) <= 24)
      ) {
        console.log('num')
        setDuration(e.currentTarget.value.replace(/^(\d*\.\d{0,1}).*$/, '$1'))
      }
    }
  }
  const handleChangeAmount = (e) => {
    if (/^\d*$/.test(e.currentTarget.value)) {
      if (
        !e.currentTarget.value.includes('e') &&
        !e.currentTarget.value.includes('E')
      ) {
        setAmount(e.currentTarget.value)
      }
    }
  }
  const convertMinutesToHours = (duration) => {
    const hours = Math.ceil(duration / 60)
    return hours
  }
  const keysToRemove = [
    'representingPersonByTransport',
    'representingPersonByCar',
    'zipCodeFrom',
    'zipCodeTo',
    'travelCost',
    'receiptUpload',
    'earningsLoss',
    'amount',
  ]

  const filterObject = (obj, keysToExclude) => {
    return Object.keys(obj)
      .filter((key) => !keysToExclude.includes(key)) // Exclude specified keys
      .reduce((acc, key) => {
        acc[key] = obj[key] // Add remaining keys to the new object
        return acc
      }, {})
  }
  const filteredRepresentation = filterObject(
    representationByPrivateIndividual,
    keysToRemove,
  )
  const fliteredIndividual =
    (representativePerson.relationshipList === 'nicht verwandt' ||
      representativePerson.relationshipList === 'andere Verwandtschaft') &&
    (representativePerson.relationshipByMarriage ===
      'Nicht verheiratet oder verschwägert' ||
      representativePerson.relationshipByMarriage ===
        'Anders verwandt oder verschwägert') &&
    representationByPrivateIndividual.individualDates.length === availableDays
      ? filteredRepresentation
      : representationByPrivateIndividual

  const travelCost = representationByPrivateIndividual.travelCost
    ? Number(representationByPrivateIndividual.travelCost)
    : 0
  const amountIndividual = representationByPrivateIndividual.amount
    ? Number(representationByPrivateIndividual.amount)
    : Number(parentState) || 0
  const totalAmount =
    representationByPrivateIndividual.individualDates.reduce((sum, item) => {
      const amount = parseFloat(item.availableDates.amount.replace('€', '').trim())
      return sum + amount
    }, 0) +
    amountIndividual +
    travelCost

  useEffect(() => {}, [totalAmount])
  useEffect(() => {}, [representationByPrivateIndividual.earningsLoss])

  const handleFile = (e) => {
    const file = e.target.files[0]
    if (!file) {
      console.log('No file selected')
      return
    }
    const allowedFileTypes = ['image/jpeg', 'image/png', 'application/pdf']
    if (!allowedFileTypes.includes(file.type)) {
      console.log('Unsupported file type. Please select a JPEG, PNG, or PDF.')
      return
    }
    const maxSizeInBytes = 5 * 1024 * 1024 // 5MB
    if (file.size > maxSizeInBytes) {
      console.log('File size exceeds 5MB.')
      return
    }
    // console.log('Selected file:', file)

    let formData = new FormData()
    formData.append('file', file)
    uploadFile(formData, reimbursementRef, 'RC_TRAVEL_COST_DOCUMENT')
      .then((res) => {
        // console.log('Upload success:', res)
        setFileArray((prev) => [...prev, { ...res, name: file.name }])
        setParentState(res.amazonUrl) // Update the parent state
      })
      .catch((error) => {
        console.error('Upload failed:', error)
      })
    // Update file name in UI
    setFileName(file.name)
    // file.name && inputRef.current.focus()
  }
  const handleDeleteFiles = (itemId) => {
    deleteFile(reimbursementRef, itemId).then((res) => {
      setFileArray((prev) => prev.filter((item) => item.id !== itemId))
      setQuestion('Bitte laden Sie den Beleg hoch.')
    })
  }
  const handlePrivateAnswer = (question) => {
    const newQuiz = quizPrivate.map((item, i) => {
      if (i === indexPrivate) {
        return {
          ...item,
          answers:
            typeof item.answers === 'object'
              ? {
                  date: dates[currentIndexIndividual],
                  duration: duration ? `${duration} Std.` : '0 Std.',
                  amount: amount ? `€ ${amount}` : '€ 0',
                }
              : item.type === 'file'
                ? fileArray
                : parentState,
          fileName: fileName,
          returnQuestion:
            item.question ===
              'Und die IBAN? Ich verstehe, wenn Sie diese Daten nicht mit mir teilen wollen. Bitte vergessen Sie nur dann nicht, die Angaben nachher im Ausdruck  nachzutragen.' &&
            parentState
              ? 'Beachten Sie, dass ich die IBAN nicht prüfe. Bitte prüfen Sie selbst, ob die eingegebene IBAN korrekt eingegeben wurde.'
              : (item.question ===
                    'Hatte die einspringende Person durch die Vertretung einen Verdienstausfall ?' &&
                    parentState === 'Nein') ||
                  (item.question === 'In welcher Höhe ?' && parentState)
                ? 'Sie können nun noch Bankdaten eingeben. Wenn es Ihnen lieber ist, können Sie dies auch handschriftlich nachtragen.'
                : null,
        }
      }
      return item
    })

    if (
      availableDays &&
      representationByPrivateIndividual.individualDates.length !== availableDays &&
      (representationByPrivateIndividual.individualDates[
        representationByPrivateIndividual.individualDates.length - 1
      ].availableDates?.amount ||
        representationByPrivateIndividual.individualDates[
          representationByPrivateIndividual.individualDates.length - 1
        ].availableDates?.amount === '0')
    ) {
      newQuiz.splice(
        indexPrivate + 1,
        0,
        {
          answers: {
            date: '',
            duration: '',
            amount: '',
          },
          img: Logo,
          type: 'group',
          required: false,
          questionKey: 'availableDates',
        },
        {
          question: 'War die abwesende Pflegeperson den ganzen Tag verhindert ?',
          // Select box (Less than 8 hours (default), More than 8 hours)
          answers: '',
          img: Logo,
          type: 'submit',
          required: false,
          questionKey: 'durationOfAbsence',
        },
      )
    }
    // console.log(
    //   'index',
    //   representationByPrivateIndividual.representingPersonByTransport === 'Nein' &&
    //     representationByPrivateIndividual.earningsLoss === 'Nein',
    // )
    !representationByPrivateIndividual.individualDates[
      representationByPrivateIndividual.individualDates.length - 1
    ].availableDates.amount ||
    !representationByPrivateIndividual.individualDates[
      representationByPrivateIndividual.individualDates.length - 1
    ].availableDates.duration ||
    !representationByPrivateIndividual.individualDates[
      representationByPrivateIndividual.individualDates.length - 1
    ].durationOfAbsence
      ? dispatch(
          setIndividual(
            Object.keys(representationByPrivateIndividual)[0],
            representationByPrivateIndividual.individualDates[
              representationByPrivateIndividual.individualDates.length - 1
            ].availableDates.amount
              ? parentState
              : {
                  date: dates[currentIndexIndividual],
                  duration: duration ? `${duration} Std.` : '0 Std.',
                  amount: amount ? `€ ${amount}` : '€ 0',
                },
            representationByPrivateIndividual.individualDates.length - 1,
            representationByPrivateIndividual.individualDates[
              representationByPrivateIndividual.individualDates.length - 1
            ].availableDates.amount
              ? 'durationOfAbsence'
              : 'availableDates',
            availableDays,
          ),
        )
      : dispatch(
          setIndividual(
            Object.keys(fliteredIndividual)[
              representativePerson.personRepresenting === 'Nein' &&
              representativePerson.commerciallyActive === 'Ja'
                ? removedItem +
                  8 -
                  (representationByPrivateIndividual.individualDates.length - 1)
                : representationByPrivateIndividual.representingPersonByTransport ===
                      'Ja' &&
                    representationByPrivateIndividual.earningsLoss === 'Nein' &&
                    representationByPrivateIndividual.individualDates.length !== 1
                  ? indexPrivate - 2 * availableDays + 2
                  : representationByPrivateIndividual.representingPersonByTransport ===
                        'Ja' &&
                      representationByPrivateIndividual.earningsLoss === 'Nein' &&
                      representationByPrivateIndividual.individualDates.length === 1
                    ? removedItem + 1
                    : representationByPrivateIndividual.representingPersonByTransport ===
                          'Nein' &&
                        representationByPrivateIndividual.earningsLoss === 'Nein'
                      ? removedItem +
                        6 -
                        (representationByPrivateIndividual.individualDates.length -
                          1)
                      : representationByPrivateIndividual.representingPersonByTransport ===
                            '-' &&
                          representationByPrivateIndividual.earningsLoss === 'Nein'
                        ? indexPrivate - 2 * availableDays + 2
                        : representationByPrivateIndividual.representingPersonByTransport ===
                            'Nein'
                          ? removedItem +
                            5 -
                            (representationByPrivateIndividual.individualDates
                              .length -
                              1)
                          : notObjIndex -
                            (representationByPrivateIndividual.individualDates
                              .length -
                              1)
            ],
            Object.keys(fliteredIndividual)[
              notObjIndex -
                (representationByPrivateIndividual.individualDates.length - 1)
            ] === 'receiptUpload'
              ? fileArray
              : parentState,
            null,
            null,
          ),
        )

    dispatch(setPrivateIndividual(newQuiz, indexPrivate + 1))

    if (
      indexPrivate ===
        2 * representationByPrivateIndividual.individualDates.length &&
      parentState === 'Nein'
    ) {
      const tupdatedQuestions = [
        ...newQuiz.slice(
          0,
          2 * representationByPrivateIndividual.individualDates.length + 1,
        ),
        ...listEntryRepresentationByPrivateIndividual.slice(8),
      ]
      dispatch(
        setPrivateIndividual(
          tupdatedQuestions,
          representationByPrivateIndividual.individualDates.length === 1
            ? 3
            : 2 * representationByPrivateIndividual.individualDates.length + 1,
        ),
      )
    }

    if (
      representationByPrivateIndividual.representingPersonByTransport &&
      parentState === 'Nein'
    ) {
      const tupdatedQuestions = [
        ...newQuiz.slice(0, indexPrivate + 1),
        ...listEntryRepresentationByPrivateIndividual.slice(10),
      ]
      dispatch(setPrivateIndividual(tupdatedQuestions, indexPrivate + 1))
    }
    setParentState('')
    setAmount('')
    setDuration('')
  }

  const handleChangePrivateCalendar = (e) => {
    console.log(e)
    setParentState(moment(e).format('DD.MM.YYYY'))
    setShowCalendar(false)
  }
  const convertToDate = (dateString) => {
    const [day, month, year] = dateString.split('.')
    const date = new Date(year, month - 1, day)
    return date.toString()
  }
  const handleShowPrivateCalendar = () => {
    if (!showCalendar) {
      setShowCalendar(true)
    } else {
      setShowCalendar(false)
    }
  }
  return (
    <>
      {quizPrivate?.map((item, i) => {
        if (i === indexPrivate) {
          switch (item?.type) {
            case 'group':
              return (
                <div className={styles.group}>
                  <div>
                    <input
                      placeholder="Datum"
                      value={dates[currentIndexIndividual]}
                      readOnly={true}
                    />
                    <img
                      src={CalendarIcon}
                      alt={CalendarIcon}
                      onClick={handleShowPrivateCalendar}
                    />
                  </div>
                  <div>
                    <input
                      required
                      placeholder={'Dauer/Std.'}
                      value={duration}
                      type={'text'}
                      step="0.1"
                      pattern=""
                      // onInput={(e) =>
                      //   (e.currentTarget.value = e.currentTarget.value.slice(0, 2))
                      // }

                      onKeyDown={(e) => {
                        if (e.key === 'Enter' && parentState) handlePrivateAnswer()
                      }}
                      key={i}
                      onChange={(e) => handleChangeDuration(e)}
                      autoFocus={true}
                    />
                    <img src={Time} alt={Time} />
                  </div>

                  <div>
                    <input
                      type={'text'}
                      pattern=""
                      placeholder={'Betrag'}
                      value={amount}
                      onChange={(e) => handleChangeAmount(e)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' && parentState) handleChangeAmount(e)
                      }}
                      key={i}
                      autoFocus={true}
                    />
                    <img src={Amount} alt={Amount} />
                  </div>
                </div>
              )

            case 'submit':
              return (
                <span ref={buttonGroupRefPrivate}>
                  <input
                    type={'submit'}
                    value={'Ja'}
                    onClick={(e) => handleClick(e, item.question)}
                    key={i}
                    className={styles.care}
                  />
                  <input
                    type={'submit'}
                    value={'Nein'}
                    onClick={(e) => handleClick(e, item.question)}
                    key={i}
                    className={styles.care}
                    autoFocus={true}
                  />
                </span>
              )
            case 'file':
              return (
                <>
                  <span
                    className={cx(styles.imageUpload, {
                      [styles.travelFiles]: fileArray.length > 0,
                    })}
                  >
                    <div>
                      {windowWidth.width <= 910
                        ? fileArray
                            .map((item) => {
                              return (
                                <div>
                                  <span>{item.name}</span>
                                  <button>
                                    <img
                                      src={Close}
                                      alt={Close}
                                      onClick={() => handleDeleteFiles(item.id)}
                                    />
                                  </button>
                                </div>
                              )
                            })
                            .slice(0, 1)
                        : fileArray
                            .map((item) => {
                              return (
                                <div>
                                  <span>{item.name}</span>
                                  <button>
                                    <img
                                      src={Close}
                                      alt={Close}
                                      onClick={() => handleDeleteFiles(item.id)}
                                    />
                                  </button>
                                </div>
                              )
                            })
                            .slice(0, 2)}
                    </div>
                    {(fileArray.length >= 3 ||
                      (windowWidth.width <= 910 && fileArray.length >= 2)) && (
                      <div
                        className={styles.multiFiles}
                        onClick={() => setOpenFiles(!openFiles)}
                      >
                        {!!openFiles && (
                          <div>
                            {fileArray.map((item) => {
                              return (
                                <div>
                                  {item.name}
                                  <button>
                                    <img
                                      src={Close}
                                      alt={Close}
                                      onClick={() => handleDeleteFiles(item.id)}
                                    />
                                  </button>
                                </div>
                              )
                            })}
                          </div>
                        )}
                        +&nbsp;
                        {windowWidth.width <= 910 && fileArray.length >= 2
                          ? fileArray.length - 1
                          : fileArray.length - 2}
                      </div>
                    )}
                    <label htmlFor="file-input">
                      <img src={AttachFile} alt="Attach File" />
                    </label>
                    <input
                      id="file-input"
                      type="file"
                      onChange={handleFile}
                      accept="image/jpeg,image/png,.pdf"
                    />
                  </span>
                  {fileArray.length === 0 && (
                    <input
                      type="text"
                      placeholder="Datei anhängen"
                      value={fileArray.length === 0 ? '' : fileName}
                      className={styles.attach}
                      readOnly
                      ref={inputRef}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' && parentState) handlePrivateAnswer()
                      }}
                    />
                  )}
                </>
              )
            case 'number':
              return (
                <div>
                  <input
                    type={'number'}
                    pattern=""
                    placeholder={'Geben Sie eine Antwort ein.'}
                    value={parentState}
                    onChange={(e) => handleChangeAnswer(e, null, item.type)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && parentState) handlePrivateAnswer()
                    }}
                    key={i}
                    autoFocus={true}
                  />
                  {/*<img src={*/}
                  {/*    item.question === 'Respite care 1: Remuneration' || item.question === 'Respite care 2: Remuneration' ?*/}
                  {/*        Euro : KM*/}
                  {/*} alt={Euro} />*/}
                </div>
              )

            case 'text':
              return (
                <input
                  type={'text'}
                  pattern=""
                  placeholder={'Geben Sie eine Antwort ein.'}
                  value={parentState}
                  onChange={(e) => handleChangeAnswer(e)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && parentState) handlePrivateAnswer()
                  }}
                  key={i}
                  autoFocus={true}
                />
              )
            case 'date':
              return (
                <div>
                  <input
                    placeholder="Datum auswählen"
                    value={
                      !parentState
                        ? moment(
                            new Date(
                              moment().year(),
                              moment().month(),
                              moment().date(),
                            ),
                          ).format('DD.MM.YYYY')
                        : moment(convertToDate(parentState)).format('DD.MM.YYYY')
                    }
                    required
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && parentState) handlePrivateAnswer()
                    }}
                    key={i}
                    autoFocus={true}
                    onClick={handleShowPrivateCalendar}
                  />
                  <img
                    src={CalendarIcon}
                    alt={CalendarIcon}
                    onClick={handleShowPrivateCalendar}
                  />
                  {!!showCalendar && (
                    <Calendar
                      onChange={(e) => handleChangePrivateCalendar(e)}
                      value={
                        !parentState
                          ? new Date(
                              moment().year(),
                              moment().month(),
                              moment().date(),
                            )
                          : convertToDate(parentState)
                      }
                      className={styles.reactCalendar}
                      nextLabel={<img src={RightArrow} alt={'next'} />}
                      prevLabel={<img src={LeftArrow} alt={'Previous'} />}
                      next2Label={null}
                      prev2Label={null}
                      tileDisabled={({ date, view }) => {
                        if (view === 'year') {
                          return (
                            date.getFullYear() > currentDate.getFullYear() ||
                            (date.getFullYear() === currentDate.getFullYear() &&
                              date.getMonth() > currentDate.getMonth())
                          )
                        }
                        return false
                      }}
                      locale={'de'}
                    />
                  )}
                </div>
              )
          }
        }
      })}
      <button
        disabled={
          (question === 'Möchten Sie ein anderes Datum hinzufügen?' &&
            !parentState) ||
          (!parentState && !duration && !amount) ||
          (question === 'Bitte laden Sie den Beleg hoch.' && fileArray.length === 0)
        }
        className={cx({
          [styles.btnDisabled]:
            (question === 'Möchten Sie ein anderes Datum hinzufügen?' &&
              !parentState) ||
            (!parentState && !duration && !amount) ||
            (question === 'Bitte laden Sie den Beleg hoch.' &&
              fileArray.length === 0),
        })}
        onClick={() => handlePrivateAnswer(question)}
      >
        <img src={ArrowBtn} alt={ArrowBtn} />
      </button>
    </>
  )
}
export default QuizPrivateIndividual

// let addObject = Object.entries(representationByPrivateIndividual).filter((item)=>typeof item[1] === 'object')
// let addString = Object.entries(representationByPrivateIndividual).filter((item)=>typeof item[1] === 'string')
// const newObj = Object.fromEntries([...addObject, ...addString])
// console.log(newObj);
